import { RoleType } from "@cca/components";
import { isActivityCompletedOrModified } from "@core/utilsV2";
import domPurify from "dompurify";
import { useCallback, useMemo, useState } from "react";

import { GradePanel, OverallFeedbackPreview } from "../PlayerV2";
import { GradePanelProps } from "../PlayerV2/components/GradePanel";

export type ActivityPlayerHeaderProps = GradePanelProps;

export const ActivityPlayerHeader = (props: ActivityPlayerHeaderProps) => {
  const { gradeMetadata, metadata } = props;

  const sanitizedFeedback = useMemo(
    () =>
      domPurify.sanitize(gradeMetadata?.teacherFeedback ?? "", {
        USE_PROFILES: { html: true },
      }),
    [gradeMetadata?.teacherFeedback],
  );

  const [isOverallFeedbackExpanded, setIsOverallFeedbackExpanded] =
    useState(false);

  const canViewOverallFeedback =
    metadata?.role === RoleType.Learner &&
    isActivityCompletedOrModified(metadata?.activityStatus) &&
    Boolean(gradeMetadata?.teacherFeedback);

  const toggleFeedback = useCallback(
    () => setIsOverallFeedbackExpanded((prev) => !prev),
    [],
  );

  return (
    <>
      <GradePanel {...props} />
      {canViewOverallFeedback && (
        <OverallFeedbackPreview
          expanded={isOverallFeedbackExpanded}
          feedbackHtml={sanitizedFeedback}
          onToggle={toggleFeedback}
        />
      )}
    </>
  );
};
